import { render } from "./WMWap.vue?vue&type=template&id=7ab9e454&scoped=true"
import script from "./WMWap.vue?vue&type=script&lang=js"
export * from "./WMWap.vue?vue&type=script&lang=js"

import "./WMWap.vue?vue&type=style&index=0&id=7ab9e454&lang=scss&scoped=true"

import exportComponent from "D:\\Project\\oversea-website\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ab9e454"]])

export default __exports__